import {Component, Mixins, Prop} from 'vue-property-decorator';
import {mapGetters} from 'vuex';

import WebpartTemplate from "@webparts/components/webparts/base/WebpartTemplate.vue";
import WebpartBase from "@webparts/components/webparts/base/WebpartBase";
import NoData from "@webparts/components/common/NoData.vue";
import { LoadingBar } from "@appbase/components/loading";
import ProcessItem from "@webparts/components/webparts/YASKAWA/Task/ProcessItem.vue";

import * as usertypes from "@account/store/types";
import api from "@webparts/api";
import { getLangProperty } from '@appbase/util'

@Component({
    name: 'task-process-webpart',
    components: {
        WebpartTemplate, NoData, LoadingBar, ProcessItem
    },
    computed: {
        ...mapGetters({
            user: usertypes.USER,
        })
    }
})
export default class TaskProcessWebpart extends Mixins(WebpartBase) {

    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    user!: account.TUser;

    processes: task.webpartProcessResponse[] = [];

    get processCount(){
        return this.processes.length;
    }

    load(){
        this.loadTaskProcessList();
    }

    goToTaskProcess(){
        const findTaskProcess = (menus: appbase.cache.TMenuItem[]): appbase.cache.TMenuItem | null => {
            for (var m of menus) {
                if (m.baseUrl?.toLowerCase().includes("task")) return m;
                else if (m.hasChildren) {
                    const sub = findTaskProcess(m.children);
                    if (sub) return sub;
                }
            }
            return null;
        };

        var id = findTaskProcess(this.portalCache.menu.items);

        if (id) {
            window.location.href = `/task/process/myprocess?MENUID=${id.menuId}`;
        } else {
            (window as any).alertAsync(this.$t("관리자에게_문의하세요."));
            return;
        }
    }

    private async loadTaskProcessList() {
        this.loading = true;
        try{
            this.processes = await api.task.getProcessList();
            this.loading = false;
        }
        catch(error){
            console.error(error);
            this.loading = false;
        }
    }

    private initializePreview() {
        this.processes = [
            {
                processId: 4,
                processName: "출장",
                firstSubject: null,
                firstApplicationName: null,
                prevTask: null,                
                waitTask: {
                    processId: 4,
                    processTaskId: 7,
                    processName: "출장",
                    processTaskName: "출정계획서 상신",
                    applicationId: null,
                    apmId: null,
                    subject: null,
                    order: 0,
                    description: null,
                    taskOrder: 1,
                    statusCode: "T_WAIT"
                },
                nextTask: {
                    processId: 4,
                    processTaskId: 8,
                    processName: "출장",
                    processTaskName: "교통편 예약",
                    applicationId: null,
                    apmId: null,
                    subject: null,
                    order: 0,
                    description: null,
                    taskOrder: 2,
                    statusCode: "T_WAIT"
                }
            },
            {
                processId: 5,
                processName: "채용",
                firstSubject: null,
                firstApplicationName: null,
                prevTask: null,
                waitTask: {
                    processId: 5,
                    processTaskId: 13,
                    processName: "채용",
                    processTaskName: "인력 충원서 상신",
                    applicationId: null,
                    apmId: null,
                    subject: null,
                    order: 0,
                    description: null,
                    taskOrder: 1,
                    statusCode: "T_WAIT"
                },
                nextTask: {
                    processId: 5,
                    processTaskId: 14,
                    processName: "채용",
                    processTaskName: "채용 공고",
                    applicationId: null,
                    apmId: null,
                    subject: null,
                    order: 0,
                    description: null,
                    taskOrder: 2,
                    statusCode: "T_WAIT"
                }
            } as task.webpartProcessResponse
        ]
    }

    created(){
        if(this.preview){
            this.initializePreview()
        }
        else {
            this.load();
        }
    }
}